<template>
  <div class="talent-wrap">
    <div class="talent-body-wrap home-mini-width hom-max-width">
      <TalentInfo :title="'技术团队'"></TalentInfo>
      <TitleCard
        title="人才信息"
        :loading="loading"
        :isEmpty="isEmpty"
        :type="'firstCard'"
        @moreClick="toRouter('talentList')"
      >
        <div class="searchCard">
          <div class="spanning-wrap" v-if="loading">
            <a-spin class="spin-item" :spinning="loading" />
          </div>
          <Empty v-else-if="isEmpty"></Empty>
          <a-row :gutter="[16, 16]" v-else>
            <a-col v-for="item in resultList" :key="item.id" :span="8">
              <div class="user-card" @click="toDetail(item.id)">
                <div class="avatorImg">
                  <MediaWrap class="audio-wrap" :url="getUrl(item)"></MediaWrap>
                </div>
                <div class="infos-wrap">
                  <div class="name">{{ item.name }}</div>
                  <div class="description-wrap">
                    简介：{{ item.introduction }}
                  </div>
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </TitleCard>
    </div>
  </div>
</template>

<script>
import { filterOptions } from './config'
import { getTalentDataList, getTeamDataList } from '@/api/MTalentData.js'
import Empty from '@/components/common/Empty'

import TalentInfo from '@/views/MPlatformPortal/components/talentList'
export default {
  data() {
    return {
      loading: false,
      isEmpty: false,
      resultList: [],
      filterOptions, // 多选过滤
      searchParams: {
        industry: '',
        expertsType: '',
        pageSize: 6,
        pageNum: 1
      },
      talentList: [],
      isEmptyTeam: false,
      loadingTeam: false
    }
  },
  components: {
    Empty,
    TalentInfo
  },
  mounted() {
    this.loadData()
  },
  methods: {
    toRouter(router, params) {
      this.$router.push({ name: router, query: { ...params } })
    },
    // 加载数据
    async loadData() {
      try {
        this.loading = true
        const { data } = await getTalentDataList(this.searchParams)
        const { rows } = data
        this.isEmpty = rows.length === 0
        this.resultList = rows
        let params = {
          status: 1,
          pageNum: 1,
          pageSize: 3
        }
        const data1 = await getTeamDataList(params)
        this.talentList = data1.rows
        this.talentList.forEach(item => {
          item.img = this.getUrl(item)
        })
        this.isEmptyTeam = this.talentList.length === 0
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    // 点击选择条件进行过滤
    mutipleChacked(params) {
      const datas = {}
      Object.keys(params).forEach(key => {
        const data = params[key]
        if (Object.keys(data).length === 0) return
        const {
          instance: { prop },
          value
        } = data
        datas[prop] = value
      })
      this.searchParams = datas
      this.loadData()
    },
    // 跳转详情
    toDetail(uid) {
      this.$router.push({ name: 'talentDetail', query: { uid } })
    },
    getUrl(item) {
      if (item.fileVo !== null && item.fileVo.length > 0) {
        return item.fileVo[0].filePath
      } else {
        return ''
      }
    }
  }
}
</script>
<style scoped>
.infos-wrap {
  display: inline-block;
}
</style>
